import { gql } from "@apollo/client";

export const CREATE_PAYMENT_FOR_EXTENSiON = gql`
  mutation createPaymentForExtension($payment: CreatePaymentInput!, $autoCharge: Boolean, $convergePOSTransaction: Boolean) {
    createPaymentForExtension(payment: $payment, autoCharge: $autoCharge, convergePOSTransaction: $convergePOSTransaction) {
      success
      message
      payment {
        id
        booking {
          id
        }
        invoice {
          id
        }
        stripeCheckoutSessionId
        convergePaymentSessionUrl
        convergePaymentLinkUrl
        convergeUSSessionToken
        bookingReference
      }
    }
  }
`;